import React, {useState, useEffect, useContext, useRef} from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter, IonText, IonInput } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';

import { ShowScopePicsModal } from './Modal_ShowScopePics';
import { ViewInvoiceModal } from './Modal_ViewInvoice';
import { PayModal_ProService} from './Modal_Pay_ProService';


export function ConsultationDetailsModal_Customer(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewConsultationDetailData, setViewConsultationDetailData] = useState([]);


    let [consultationID, setConsultationID] = useState(props.data.consultationID);
    let [consultationStatus, setConsultationStatus] = useState(null);

    let [viewScopeList, setViewScopeList] = useState([]);
    let [viewScopeEstimates, setViewScopeEstimates] = useState([]);
    let [viewScopeExpenses, setViewScopeExpenses] = useState([]);
    let [scopePicsModal, setScopePicsModal] = useState(false);
    let [scopePicsModal_finished, setScopePicsModal_finished] = useState(false);
    let [showAddScopeModal, setShowAddScopeModal] = useState(false);

    let [createScopeName, setCreateScopeName] = useState('');
    let [createScopeDescription, setCreateScopeDescription] = useState('');

    let [workmanshipTotal, setWorkmanshipTotal] = useState('');

    let [showAddExpenseModal, setShowAddExpenseModal] = useState(false);

    let [estimateLineNumber, setEstimateLineNumber] = useState(null);
    let [viewInvoice, setViewInvoice] = useState(false);
    let [invoiceID, setInvoiceID] = useState('');
    let [invoiceForm, setInvoiceForm] = useState('');

    let [payTotal, setPayTotal] = useState('');

    const slidesRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    let [checkInNonMemberPaymentType, setCheckInNonMemberPaymentType ] = useState('mm');

    let [ openPayModal, setOpenPayModal] = useState(false);
    
    const [cartList, setCartList] = useState([]);
    let [internalReferenceID, setInternalReferenceID] = useState(props.data.externalID);

    let cartItems = {
    id: props.data.consultationID,
    name: "Payment to Consultation - "+props.data.consultationID,
    price: payTotal,
    quantity: 1,
    };

    const parseArray = (raw) => {
    try {
        let v = raw;
        if (typeof v === "string") v = JSON.parse(v);
        while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
        return Array.isArray(v) ? v : [];
    } catch {
        console.warn("Bad itemID_list JSON:", raw);
        return [];
    }
    };


   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_consultation_details',
                    user: acctID,
                    xCompanyID_public: props.data.merchantAccountID,
                    xConsultationID: props.data.consultationID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                let consultationCols = rows[0].split('|');

                    setConsultationID(consultationCols[0]);
                    setConsultationStatus(consultationCols[10]);
                    setInvoiceID(consultationCols[11]);
                    setInvoiceForm(consultationCols[12]);


                for (let rownum = 1; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewScopeList((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            consultationID: cols[0],
                            scopeNumber: cols[1],
                            scopeName: cols[3],
                            scopeDescription: cols[4],
                            workmanshipTotal: cols[5],
                            scopeExpenses: cols[6],
                            dateLogged: cols[7],
                            assigned: cols[8],
                            lastModified: cols[9],
                            status: cols[10],
                            scopePic1: cols[11],
                            scopePic2: cols[12],
                            scopePic3: cols[13],
                            scopePic4: cols[14],
                            scopePic1_finished: cols[15],
                            scopePic2_finished: cols[16],
                            scopePic3_finished: cols[17],
                            scopePic4_finished: cols[18],
                            scope_items: parseArray(cols[19]),
                        })
                    });


                        /*let cols_estimates = cols[2].split('#');

                        setViewScopeEstimates((prevAvailableRooms) => {
                            return prevAvailableRooms.concat({
                                consultationID: cols_estimates[0],
                                scopeNumber: cols_estimates[1],
                                estimateLineNumber: cols_estimates[2],
                                itemID: cols_estimates[3],
                                itemName: cols_estimates[4],
                                itemDescription: cols_estimates[5],
                                itemQuantity: cols_estimates[6],
                                itemEstimatedPrice: parseFloat(cols_estimates[7]).toFixed(2),

                            })
                        });


                        let cols_expenses = cols[2].split('$');

                        setViewScopeExpenses((prevAvailableRooms) => {
                            return prevAvailableRooms.concat({
                                consultationID: cols_expenses[0],
                                scopeNumber: cols_expenses[1],
                                expenseLineNumber: cols_expenses[2],
                                itemID: cols_expenses[3],
                                itemName: cols_expenses[4],
                                itemDescription: cols_expenses[5],
                                itemQuantity: cols_expenses[6],
                                itemPrice: parseFloat(cols_expenses[7]).toFixed(2),

                            })
                        });*/

                } 
            })
        
    }, []);


    function send_customer_approvalRequest()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_send_customerApproval',
                user: acctID,
                xConsultationID: props.data.consultationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }
    
function confirmCheckout(event)
{
    setOpenPayModal(false);

    //alert(checkInRoomID);
    //alert(roomSalePrice);

        //e.preventDefault();

        if(props.data.status != 'ACTIVE_PROJECT')
        {

        
        let formData = new FormData();
        //formData.append('user', acctID);
        //formData.append('sessionID', sessionID);
        //formData.append('xImageFile', checkInAttachment_ID);

        const requestOptions = {
            method: 'POST',
            //mode: 'no-cors',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('content-type', 'application/json'), 
            body: JSON.stringify({
                Tracker: '74706_confirmCheckout_proService_public',
                user: acctID,
                xCompanyID_public: props.data.merchantAccountID,
                xCartList:  cartList,
                xCartFirstName: props.data.firstName,
                xCartLastName: props.data.lastName,
                xCartMobileNumber: props.data.mtnCompanyPhoneNumber,
                //xCartEmail: enterEmailRef.current.value.replace(/\s+/g, ''),
                xCartSubtotal: payTotal,
                xCartCheckoutTotal: payTotal,
                xCartLatitude: props.data.cartLatitude,
                xCartLongitude: props.data.cartLongitude,
                //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,    
                xCartNonMemberPaymentType: checkInNonMemberPaymentType,
                xUserStatus: "member",
                xInternalReferenceID: internalReferenceID,
                //xOrderID: event[1],
                //xOrderID_customer: event[2],
                xOrderID_payStatus: event[0],
                //xStorefront: storefront,
                sessionID: sessionID,
                

            }),
        }

        //alert('Inside GetAvaialbleRoom AFTER upload');
        //alert(baseURL);

        let newBaseURL = 'https://ghanaverified.com';
        if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
        {
            newBaseURL = 'https://ghanaverifiedtest.com'
        }

        fetch(baseURL+'ghanaverified_proService/', requestOptions)
        //fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
            
            alert("CHECKOUT COMPLETE.  PLEASE VIEW ORDER/INVOICE IN YOUr ACCOUNT. INVOICE ID IS - "+event[4])

            window.location.href = '/';
    
        })

        props.closeModal(false);

    }
    else
    {
            alert("CHECKOUT COMPLETE.  PLEASE VIEW ORDER/INVOICE IN YOUr ACCOUNT. INVOICE ID IS - "+event[4])

            window.location.href = '/';
    }

}

    function viewExpenseDetailsHandler(event) {


        //setExpenseID(event[1]);
        //setTotalAmount(event[2]);

        //setShowExpenseDetailsModal(event[0]);
    }

    function payModalHandler(e)
{
    //e.preventDefault();
    setCartList((prevCartList) => {
        const updatedCartList = [...prevCartList, cartItems]; // Keep old items + new one

        // Store the updated list in local storage
        //addStorage_cart(updatedCartList);

        return updatedCartList; // Update state
    });

    setOpenPayModal(true);

    //confirmGuestBooking(e);
}

  const slideTo = async (index) => {
    if (slidesRef.current) {
      await slidesRef.current.slideTo(index);
      setActiveIndex(index);
    }
  };

  const onSlideChange = async () => {
    const index = await slidesRef.current.getActiveIndex();
    setActiveIndex(index);
  };

    function closeModalHandler() {

        setViewConsultationDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader style={{color: 'black'}}>
            <IonGrid >
                    <IonRow>
                        <IonCol> Consultation ID</IonCol>
                        <IonCol> {props.data.consultationID} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
        <IonGrid>
            <IonRow>
                <IonCol>
                    <IonText>PAY AMOUNT</IonText>
                </IonCol>
                <IonCol>
                        <IonInput className='professional-input' type='number' value={ payTotal }  placeholder='Enter Pay Amount - 22 Letter Max' autocomplete='off' onIonChange={(e) => setPayTotal(e.target.value)}  required></IonInput>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonButton  onClick={() => payModalHandler()}> Pay </IonButton>
                </IonCol>
            </IonRow>
            <IonRow className="slide-index-row">
                {viewScopeList.map((_, index) => (
                <IonCol key={index} size="auto">
                    <IonButton
                    fill={activeIndex === index ? 'solid' : 'outline'}
                    color={activeIndex === index ? 'primary' : 'medium'}
                    className="slide-index-btn"
                    onClick={() => slideTo(index)}
                    >
                    {index + 1}
                    </IonButton>
                </IonCol>
                ))}
            </IonRow>
        </IonGrid>
        <IonSlides pager='false' options={{direction: 'horizontal'}} ref={slidesRef} onIonSlideDidChange={onSlideChange}>

        {viewScopeList.map((detailData) =>   {
        return (
        <IonSlide key={detailData.scopeNumber}>

                    <IonGrid className='gridContent_multiple_top_grid'>
                                            <IonRow>
                                                <IonCol size='6'>
                                                    <IonText for='searchSupplierName'>Scope Name:</IonText>
                                                </IonCol>
                                                <IonCol size='6'>
                                                    {/*<IonInput className='professional-input' type='text' value={ createScopeName }  placeholder='Enter Scope Name' autocomplete='off' onIonChange={(e) => setCreateScopeName(e.target.value)} required></IonInput>*/}
                                                    <IonText className='professional-text'>{ detailData.scopeName }</IonText>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol size='6'>
                                                    <IonText for='searchSupplierName'>Description:</IonText>
                                                </IonCol>
                                                <IonCol size='6'>
                                                    {/*<IonInput className='professional-input' type='text' value={ createScopeDescription }  placeholder='Enter Scope Name' autocomplete='off' onIonChange={(e) => setCreateScopeDescription(e.target.value)} required></IonInput>*/}
                                                    <IonText className='professional-text'>{ detailData.scopeDescription }</IonText>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol size='6'>
                                                    <IonText for='searchSupplierName'>Workmanship:</IonText>
                                                </IonCol>
                                                <IonCol size='6'>
                                                    {/*<IonInput className='professional-input' type='text' value={ workmanshipTotal }  placeholder='Enter Scope Name' autocomplete='off' onIonChange={(e) => setWorkmanshipTotal(e.target.value)} required></IonInput>*/}
                                                    <IonText className='professional-text'>{ detailData.workmanshipTotal }</IonText>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow >
                                                <IonCol >Invoice</IonCol>
                                                <IonCol >{"FILE"}</IonCol>
                                                <IonCol >
                                                    <IonButton  onClick={() => setViewInvoice(true)}> View </IonButton>
                                                </IonCol>

                                            {viewInvoice == true && <ViewInvoiceModal openModal={ viewInvoice } closeModal={() => setViewInvoice(false)} data={{
                                                                    fileLocation: `/api/form/${invoiceForm}/${schema}`, 
                                                                    }}></ViewInvoiceModal>}
                                            </IonRow>
                                            <IonRow >
                                                <IonCol >Images Before</IonCol>
                                                <IonCol >{detailData.assigned}</IonCol>
                                                <IonCol >
                                                    <ShowScopePicsModal openModal={ scopePicsModal } closeModal={() => setScopePicsModal(false)} data={{
                                                    scopePic1: detailData.scopePic1, 
                                                    scopePic2: detailData.scopePic2, 
                                                    scopePic3: detailData.scopePic3, 
                                                    scopePic4: detailData.scopePic4, 
                                                    scopeNumber: detailData.scopeNumber, 
                                                    scopeEstimateAmount: detailData.scopeEstimateAmount,
                                                    scopeExpenses: detailData.scopeExpenses,
                                                    consultationID: props.data.consultationID
                                                    }}></ShowScopePicsModal>
                                                    <IonButton onClick={() => setScopePicsModal(true)}> Add/View </IonButton>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow >
                                                <IonCol >Images After</IonCol>
                                                <IonCol >{detailData.assigned}</IonCol>
                                                <IonCol >
                                                    <ShowScopePicsModal openModal={ scopePicsModal_finished } closeModal={() => setScopePicsModal_finished(false)} data={{
                                                    scopePic1: detailData.scopePic1_finished, 
                                                    scopePic2: detailData.scopePic2_finished, 
                                                    scopePic3: detailData.scopePic3_finished, 
                                                    scopePic4: detailData.scopePic4_finished, 
                                                    scopeNumber: detailData.scopeNumber, 
                                                    scopeEstimateAmount: detailData.scopeEstimateAmount,
                                                    scopeExpenses: detailData.scopeExpenses,
                                                    consultationID: props.data.consultationID
                                                    }}></ShowScopePicsModal>
                                                    <IonButton onClick={() => setScopePicsModal_finished(true)}> Add/View </IonButton>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                    <h4>Scope Expenses</h4>
                                                </IonCol>
                                            </IonRow>
                                             <IonRow >
                                                        <IonCol size='3'> <h5> Supplier Name </h5> </IonCol>
                                                        {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                                        {/*<IonCol className='appGridCol' size='3'> <h3> Expense Description </h3> </IonCol>*/}
                                                        <IonCol size='3'> <h5> Date Logged </h5> </IonCol>
                                                        <IonCol size='3'> <h5> Total Amount </h5> </IonCol>                                        
                                                        <IonCol size='3'> <h5> Action </h5> </IonCol>
                                                </IonRow>
                                            {detailData.scope_items.map((expenseData) =>   {
                                                return (
                                                        <IonRow key={expenseData.expenseID}>
                                                            <IonCol size='3'>{expenseData.supplierName}</IonCol>
                                                            {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                                            {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                                            <IonCol size='3'>{expenseData.dateLogged}</IonCol>
                                                            <IonCol size='3'>{expenseData.totalAmount}</IonCol>
                                                            <IonCol size='3'>

                                                                <IonButton className='appListButton' onClick={() => viewExpenseDetailsHandler([true, expenseData.expenseID, expenseData.totalAmount])}> Details </IonButton>
                                                               {/* {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteExpenseHandler([true, expenseData.expenseID])}> Delete </IonButton>}
                                                                {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                                        
                                                            </IonCol>
                                                        </IonRow>
                                                )
                                            }
                                            )}
                                        </IonGrid>

                        </IonSlide>
                        )
                   }
            )}
        </IonSlides>

        {openPayModal == true && <PayModal_ProService openModal={ openPayModal } closeModal={(event) => confirmCheckout(event)} payCloseModal={(event) => setOpenPayModal(event)} data={{
        status: props.data.status,
        companyId: props.data.merchantAccountID,
        companyPhoneNumber: props.data.mtnCompanyPhoneNumber,
        mtnCompanyPhoneNumber: props.data.mtnCompanyPhoneNumber,
        cartList: cartList,
        firstName: props.data.firstName, 
        lastName: props.data.firstName,
        mobileNumber: props.data.mobileNumber,
        payeeMessage: 'ProService Payment',
        cartSubtotal: payTotal,
        cartCheckoutTotal: payTotal,
        paymentType: checkInNonMemberPaymentType,
        payment_amount: payTotal,
        cartLatitude: props.data.cartLatitude,
        cartLongitude: props.data.cartLongitude,
        storefront: "pro_service",
        externalID: props.data.externalID,
        projectID: props.data.projectID,
        invoiceID: props.data.invoiceID,
        customerInvoiceID: props.data.customerInvoiceID,

        }}></PayModal_ProService>}

        </IonContent>


        <IonFooter className='grid_footer'>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        <IonButton onClick={closeModalHandler}> Close </IonButton>        
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>

    </IonModal>) : null}
    
    </React.Fragment>
    )
}